import {
  GET_FEEDBACK_RECORDS,
  SET_FEEDBACK_RECORDS,
  GET_FEEDBACK_QUESTION_TYPES,
  SET_FEEDBACK_TAB,
  SET_FEEDBACK_TASK,
} from '../constants/userFeedback';

export const setFeedbackTab = payload => ({
  type: SET_FEEDBACK_TAB,
  payload,
});

export const getFeedbackRecords = payload => ({
  type: GET_FEEDBACK_RECORDS,
  payload,
});

export const setFeedbackRecords = payload => ({
  type: SET_FEEDBACK_RECORDS,
  payload,
});

export const getFeedbackTypes = payload => ({
  type: GET_FEEDBACK_QUESTION_TYPES,
  payload,
});

export const setFeedbackTask = payload => ({
  type: SET_FEEDBACK_TASK,
  payload,
});
